// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dkmb","textarea":"styles_textarea__34uAz"};